import ReactDOM from 'react-dom/client';
import './globals.css';
import reportWebVitals from './reportWebVitals';
import StoreProvider from './pages/storeProvider';
import App from './routes';
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StoreProvider>
    <App />
  </StoreProvider>
);

reportWebVitals();
